export default {
    // serverURL: 'http://10.0.1.30:9935',
    serverURL: 'http://192.168.100.130:9935',
    backstageURL: 'http://192.168.100.217:192'
}
